import apiClient from "../config/apiClient";


export const fetchPurchasedDrugs = async (id, request_type) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.get(`/public/portal?url=requests/${id}/request/portal/${request_type}`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
